
define('unknown/models/pwActModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PwAct = Backbone.Model.extend({
		urlRoot:"/draftapp/users/pwreset",
		idAttribute: 'key',
		defaults: {
	    	key: null,
	    	activationType: null,
	    	activated: 0
	    },

	    initialize: function() {
	    	
	    },

	    isActivated: function() {
	    	return this.get("activated") > 0;
	    },	
	});
	
	return PwAct;  
});